var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-form',{ref:"formData",attrs:{"options":_vm.options,"labelWidth":"100px","disabled":!_vm.canEdit,"maxLabelLength":7},on:{"input":_vm.handleChange},model:{value:(_vm.formData),callback:function ($$v) {_vm.formData=$$v},expression:"formData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }